import styled from 'styled-components'

export const StyledWrapper = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const StyledTitle = styled.span`
  font-weight: 700;
  font-size: 24px;
  line-height: 30px;
  color: #00112b;
  margin-top: 14px;
`

export const StyledContent = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #00112b;
  margin-top: 10px;
  width: 600px;
  text-align: center;
  white-space: pre-line;
`
